(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('gateway-diagnostics', {
                parent: 'entity',
                url: '/gateway-diagnostics',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'global.menu.configuration.gateway.diagnostics'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/gateway-diagnostics/gateway-diagnostics.html',
                        controller: 'GatewayDiagnosticsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tkbTransfer');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
